export default {
    secure_checkout: 'Secure Checkout',
    cart: 'Cart',
    photos: 'photos',
    see_all: 'See all',
    subscription: 'Subscription',
    sold_out: 'Sold out',
    subtotal: 'Subtotal',
    discount: 'Discount',
    shipping: 'Shipping',
    free: 'free',
    total: 'Total',
    recurring_info: '* Recurring amount according to the plan',
    description: 'Description',
    has_coupon: 'Have a discount coupon? Click here.',
    enter_coupon: 'Enter Discount Coupon',
    apply: 'Apply',
    personal_data: 'Personal Data',
    full_name: 'Full Name*',
    required_field: 'This field is required',
    review_form: 'Please check the highlighted fields to complete your purchase.',
    email: 'Email*',
    phone: 'Phone/Mobile*',
    document: 'ID/Document*',
    continue: 'Continue',
    shipping_data: 'Shipping Information',
    zipcode: 'Zipcode*',
    street: 'Street Address*',
    number: 'Number*',
    complement: 'Apartment/Suite etc',
    neighborhood: 'Neighborhood*',
    city: 'City*',
    state: 'State/Province*',
    back: 'Back',
    payment_method: 'Payment Method',
    credit_card: 'Credit Card',
    billet: 'Boleto',
    pix: 'Pix',
    card_number: 'Card Number*',
    card_name: 'Name on card*',
    expiry_month: 'Expiration Month*',
    expiry_year: 'Expiration Year*',
    security_code: 'Security Code (CVV)*',
    security_code_short: 'Security Code*',
    installments: 'Installments*',
    product_not_found: 'Product not found',
    product_not_found_msg: "Unfortunately, we couldn't find the product you were looking for.",
    buy_now: 'Buy Now',
    generate_billet: 'Generate Boleto',
    pay: 'Pay',
    pix_payment: 'Pix Payment',
    billet_payment: 'Boleto Payment',
    copy_code: 'Copy Pix Code',
    copied: 'Copied!',
    billet_no_installments: 'Installments are not available for Boleto.',
    pay_until_due_date: 'Pay until the due date',
    billet_due_date_warning:
        'Pay attention to the Boleto due date. You can pay the Boleto at any bank or lottery retailer until the due date.',
    wait_payment_approval: 'Wait for payment approval',
    billet_approval_time: 'Payments via Boleto take up to 3 business days to be cleared and products released.',
    pix_payment_instructions: "Just use your bank app to make a PIX payment. It's fast and easy!",
    instant_payment: 'Instant Payment',
    pix_approval_time: 'Pix payments are processed instantly, but some banks may take a few minutes!',
    credit_card_fees: '2.99% installment fee applied to credit cards.',
    exclusive_offer_available: 'exclusive offer available',
    exclusive_offers_available: 'exclusive offers available',
    for_you: 'for you:',
    get_offer: 'Get offer',
    remove_offer: 'Remove offer',
    offer_acquired: 'Offer Acquired',
    cart_has_sold_out_product: 'Your cart has a sold out product, please remove it to finish.',
    loading: 'Loading',
    hoopay_processing: 'HooPay is processing this payment for the seller',
    type_discount_coupon: 'Enter a Discount Coupon',
    type_full_name: 'Enter your Full Name',
    type_email: 'Enter your Email',
    type_phone: 'Enter your Mobile Number',
    type_document: 'Enter your ID/Document',
    type_zipcode: 'Enter your Zipcode',
    type_street: 'Enter your Full Address',
    type_number: 'Enter your address number',
    type_neighborhood: 'Enter your Neighborhood',
    type_city: 'Enter your City',
    invalid_cpf: 'Invalid CPF/ID',
    invalid_cnpj: 'Invalid CNPJ/ID',
    invalid_email: 'This email is invalid',
    generate_pix: 'Generate PIX',
    finish_payment: 'Finish',
    order_observations: 'Order observations',
    order_observations_placeholder: 'Product details, seller name, delivery instructions or other observations',
    recaptcha_protected: 'This site is protected by Google reCAPTCHA',
    privacy_policy_terms: 'Privacy Policy and Terms of Service',
    agree_terms: 'By continuing, you agree to the Terms of Purchase',
    choose_shipping: 'Choose a shipping option',
    cannot_complete_purchase: 'At the moment it is not possible to complete this purchase',
    ok_got_it: 'Ok, got it',
    countdown_finished: 'Your time is up, get your access right now.',
    promotional_price_ending: "Don't miss this opportunity! Promotional price will end soon..",
    privacy_policy: 'Privacy policy',
    terms_of_service: 'Terms of service',
    installments_with_addition: '* Installments with addition',
    and: 'and',
    order_analyzing: 'Order under analysis',
    transaction_safety_analysis: 'Your transaction is undergoing a security analysis.',
    safety_protocol_info:
        'Rest assured, this is part of our security protocols. Your order status will soon be updated and you will receive a notification.',
    awaiting_payment: 'Awaiting payment',
    complete_purchase_payment: 'Make the payment to complete your purchase',
    pix_code: 'PIX Code',
    already_paid: 'I already made the payment',
    how_to_pay_pix: 'How to pay with PIX',
    open_bank_app: 'Open your bank app',
    open_bank_app_desc: 'Access your bank or financial institution app',
    choose_pix_option: 'Choose the PIX option',
    choose_pix_option_desc: 'Select the PIX option in the app main menu',
    scan_qr_copy_code: 'Scan the QR Code or paste the code',
    scan_qr_copy_code_desc: 'Use the camera to read the QR Code or paste the copied PIX code',
    confirm_payment_step: 'Confirm payment',
    confirm_payment_step_desc: 'Check the details and confirm the transaction',
    pix_code_copied: 'PIX code copied successfully!',
    copy_error: 'Error copying code',
    payment_not_identified: 'Payment not identified',
    billet_instructions: 'Instructions',
    billet_after_expiration_warning: 'After the due date, issue a new billet.',
    billet_do_not_accept_after_expiration: 'Do not accept payment after the due date.',
    billet_request_new_copy: 'In case of expiration, request a new copy.',
    billet_support_doubts: 'Doubts? Contact our support.',
    print_billet: 'Print Billet',
    payer_receipt: 'Payer Receipt',
    payment_location: 'Payment Location',
    beneficiary_name_label: 'Beneficiary Name / CNPJ / CPF / Address:',
    doc_date: 'Document date',
    doc_number: 'Doc. number',
    doc_type: 'Doc. species',
    acceptance: 'Acceptance',
    processing_date: 'Processing Date',
    our_number: 'Our Number',
    bank_use: 'Bank Use',
    wallet: 'Wallet',
    currency: 'Currency',
    quantity: 'Quantity',
    value: 'Value',
    doc_value_label: '(=) Document Value',
    discounts_label: '(-) Discounts/Abatements',
    interest_fine_label: '(+) Interest/Fine',
    paid_value_label: '(=) Paid Value',
    payer_name: 'Payer Name:',
    beneficiary_drawee: 'Drawee/Endorser:',
    address: 'Address',
    website: 'Website',
    expiry_date: 'Expiry Date',
    agency_code_label: 'Agency / Beneficiary Code',
    mechanical_authentication: 'Mechanical Authentication',
    compensation_slip: 'Compensation Slip',
    amount_to_pay: 'Amount to pay',
    due_date: 'Due date',
    billet_code: 'Billet Code',
    copy_code_tip: 'Copy the code above to pay in your bank app',
    download_view_pdf: 'Download/View PDF',
    payment_instructions: 'Payment Instructions',
    billet_step_1_title: 'Copy the code or download the PDF',
    billet_step_1_desc: 'Use the digit line or print the boleto to pay.',
    billet_step_2_title: 'Pay at your bank',
    billet_step_2_desc: 'Use your bank app or go to a branch/lottery retailer.',
    billet_step_3_title: 'Wait for confirmation',
    billet_step_3_desc: 'The clearing period is up to 3 business days.',
    billet_code_copied: 'Code copied successfully!',
    copy_error_billet: 'Error copying code',
    security_validation: 'Security Validation',
    security_validation_desc: 'For your protection, confirm the document registered in the order to view the details.',
    validating: 'Validating...',
    view_order: 'View Order',
    document_not_found: 'Document not found for this order',
    validation_error: 'Validation error. Please check the document.',
    your_content: 'Your Content',
    acquired_materials_description: 'Below are all the materials you have acquired',
    search_content: 'Search content...',
    external_link: 'External Link',
    download: 'Download',
    open_link: 'Open Link',
    view: 'View',
    no_content_found: 'No content found',
    try_changing_filters: 'Try changing filters or search terms',
    browser_no_video_support: 'Your browser does not support the video element.',
    all: 'All',
    images: 'Images',
    videos: 'Videos',
    documents: 'Documents',
    links: 'Links',
    image_file: 'Image file',
    video_file: 'Video file',
    download_document: 'Document for download',
    download_file: 'File for download',
    file: 'File',
    product_not_found_msg_detailed: "We couldn't find the product. Please contact the seller for more information.",
    order_refunded: 'Order Refunded',
    order_refunded_msg: 'The amount of your order has been returned.',
    order_refunded_description:
        'The refund transaction was completed successfully. The amount will be credited to the same account or invoice used for payment.',
    identifier: 'Identifier',
    loading_payment_info: 'Loading payment information...',
    oops_something_wrong: 'Oops! Something went wrong',
    order: 'Order',
    unrecognized_payment_type: 'Unrecognized payment type',
    uuid_not_provided: 'Order UUID not provided',
    order_not_found_check_uuid: 'Order not found. Check if the UUID is correct.',
    error_loading_payment_try_again: 'Error loading payment data. Please try again later.',
    payment_successful: 'Payment successful!',
    order_info: 'Order Information',
    order_number: 'Number',
    loading_items: 'Loading items...',
    date: 'Date',
    customer_data: 'Customer Data',
    cpf: 'ID/Document',
    phone_label: 'Phone',
    shipping_address: 'Shipping Address',
    support: 'Support',
    select_shipping_option: 'Select a shipping option',
    delivery: 'Delivery',
    days: 'days',
    business_days: 'business days',
    until: 'Until',
    today: 'today',
    order_delivery_forecast: 'Your order will be delivered',
    between: 'between',
    invalid_zipcode: 'Invalid Zipcode!',
    transaction_not_completed: 'Transaction not completed',
    payment_failed_gateway: 'The payment failed at the gateway. Check your data or try another method.',
    payment_status: 'Payment status',
    // card refusal reason (charges[].errorMessage.reason)
    sandbox: {
        banner: 'TEST MODE (sandbox): no real charge is made and no order is created.',
        three_ds_prompt: '[SANDBOX] Simulate the bank 3DS authentication.\n\nOK = approve  |  Cancel = decline',
        simulate_payment: 'Simulate payment (sandbox)',
        simulate_error: 'Could not simulate the payment.',
    },
    upsell: {
        title: 'Take advantage of this offer',
        card: 'Payment with the same card ending in {lastDigits}',
        confirm: 'Confirm purchase',
        processing: 'Processing...',
        other_payment: 'Pay another way',
    },
    repurchase: {
        saved_cards: 'Your saved cards',
        welcome: 'Welcome back, {name}!',
        filled: 'We filled in your details from your last purchase.',
        confirm_document: 'For your security, confirm your CPF/CNPJ ({document}).',
        not_you: 'Not you? Use other details',
        card: 'Card',
        expires: 'exp. {date}',
        other_card: 'Use another card',
        cvv_of: 'CVV of the card ending in {lastDigits}',
        remember_me: 'Remember my details for next purchases',
    },
    card_verification: {
        title: 'Confirm the amount charged to your card',
        step_open_app: 'Open your bank app or statement',
        step_find_charge: 'Find the most recent verification charge',
        step_type_amount: 'Enter the exact amount below',
        description: 'For your security, we made a verification charge between R$ {min} and R$ {max} on your card. It is refunded automatically.',
        amount_label: 'Amount charged to the card ending in {lastDigits}',
        confirm: 'Confirm amount and pay',
        confirming: 'Confirming...',
        cancel: "I can't find the charge / use another card",
        expires_in: 'Time left: {time}',
        attempts_left: 'Attempts: {attempts}',
        wrong_amount: 'Incorrect amount. Check your bank app. Attempts left: {attempts}',
        expired: 'Time to confirm is over. The verification charge will be refunded.',
        canceled: 'Verification canceled and verification charge refunded. You can try another card.',
        cancel_pending: 'Verification canceled. The verification charge will be refunded in a few minutes.',
        error: 'We could not confirm the amount. Please try again.',
        refund_note: 'The verification charge is always refunded.',
    },
    three_d_secure: {
        hint: 'Confirm the purchase with your card issuer.',
        waiting: 'Waiting for the bank confirmation...',
        error: 'We could not start the bank confirmation. Please try again.',
    },
    captcha: {
        hint: 'Complete the security check to finish your payment.',
        error: 'We could not complete the security check. Please try again.',
    },
    billing_address: {
        title: 'Billing address (optional)',
        hint: "Providing the cardholder's address increases the chances of approval.",
        zipcode: 'ZIP code',
        street: 'Street address',
        number: 'Number',
        neighborhood: 'Neighborhood',
        city: 'City',
        state: 'State',
    },
    charge_recovery: {
        pay_with_pix: 'Pay with PIX',
        pay_with_pix_hint: 'We generate the PIX right away with the same details, no need to type anything.',
        fix_cc_securityCode: 'Fix the security code',
        fix_cc_expiryMonth: 'Fix the expiration date',
        fix_cc_number: 'Fix the card number',
        use_other_card: 'Enter the card details',
    },
    charge_error: {
        insufficient_funds: {
            title: 'Insufficient funds or limit',
            hint: 'Check the available limit on your card or try another card.',
        },
        invalid_cvv: {
            title: 'Invalid security code',
            hint: 'Check the security code (CVV) on the back of your card and try again.',
        },
        expired_card: {
            title: 'Expired card',
            hint: 'Check the expiration date or use another card.',
        },
        invalid_card_data: {
            title: 'Invalid card details',
            hint: 'Check the card number, expiration date and cardholder name and try again.',
        },
        card_blocked: {
            title: 'Card blocked or restricted',
            hint: 'Contact your card issuer or use another card.',
        },
        transaction_not_allowed: {
            title: 'Purchase not allowed for this card',
            hint: 'Your card may not be enabled for online purchases. Contact your bank or use another card.',
        },
        issuer_declined: {
            title: 'Payment declined by the bank',
            hint: 'Your card issuer did not authorize the purchase. Contact them or use another card.',
        },
        suspected_fraud: {
            title: 'We could not validate this purchase',
            hint: 'For security reasons the purchase was not approved. Try another card or payment method.',
        },
        attempts_exceeded: {
            title: 'Too many attempts',
            hint: 'Wait a few minutes and try again, or use another card.',
        },
        invalid_amount: {
            title: 'Amount not allowed on card',
            hint: 'Try another payment method.',
        },
        try_again: {
            title: 'Processing instability',
            hint: 'We could not complete it right now. Wait a moment and try again.',
        },
        authentication_failed: {
            title: 'Purchase not authenticated by the bank',
            hint: 'Your card issuer did not confirm the purchase. Try again completing the bank confirmation, or use another card or payment method.',
        },
        generic: {
            title: 'Payment not authorized',
            hint: 'Check your card details or try another card or payment method.',
        },
        payment_unavailable: {
            title: 'Unable to generate the payment',
            hint: 'Please try again in a few moments or choose another payment method.',
        },
    },
    weekly: 'weekly',
    biweekly: 'biweekly',
    monthly: 'monthly',
    quarterly: 'quarterly',
    semiannual: 'semiannual',
    yearly: 'yearly',
    product_added_to_cart: 'Product added to cart',
    error_processing_payment: 'Error processing payment',
    offer_removed: 'Offer removed',
    convert_to: 'Convert to:',
    currency_brl: 'Brazilian Real (R$)',
    currency_usd: 'US Dollar ($)',
    currency_eur: 'Euro (€)',
};
